import React, { useState, useEffect } from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { MdFormatAlignLeft } from "react-icons/md";
import { Buttons, ActionButton } from "../Buttons";
import { MdLogout } from "react-icons/md";
// import { TbUserSquare } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import Dialog from "../Dialog";
import { useDispatch } from "react-redux";
import { logoutUser } from "../../services/LoginService";

import { HiOutlineUser } from "react-icons/hi";
const Header = () => {
  const Navigate = useNavigate();
  const dispatch = useDispatch();
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [username, setUsername] = useState("");
  useEffect(() => {
    const storedUsername = sessionStorage.getItem("username");
    if (storedUsername) {
      setUsername(storedUsername);
    }
  }, []);
  const handleClose = () => {
    setShowConfirmDialog(true);
  };
  const handleLogout = (confirm) => {
    setShowConfirmDialog(false);
    if (confirm) {
      dispatch(logoutUser())
        .then(() => {
          console.log("Logged out successfully");
          Navigate("/");
        })
        .catch((error) => {
          console.error("Logout failed:", error);
          alert(error);
        });
      console.log("logout Success");
    }
  };
  const options = [
    { label: "Logout", icon: <MdLogout size={20} />, onClick: handleClose },
  ];
  const handleSideBar = () => {
    console.log("Sidebar toggle triggered");
    document.body.classList.toggle("toggle-sidebar");
  };

  return (
    <>
      <Navbar expand="sm" className="bg-white shadow-sm border-bottom pos-fixed top-navbar py-2 px-3">
        <Container fluid className="px-3 px-md-4 d-flex align-items-center justify-content-between">
          <Buttons
            className="action-btn border-0 bg-transparent text-dark p-1"
            btnlabel={
              <>
                <MdFormatAlignLeft size={25} />
              </>
            }
            onClick={handleSideBar}
          />

          <div className="ms-auto d-flex align-items-center">
            <div className="profile d-flex align-items-center">
              <ActionButton
                label={
                  <>
                    <span className="mx-1">
                      <HiOutlineUser size={20} />
                    </span>
                    <span className="mx-1 fw-semibold">{username || "Guest"}</span>
                  </>
                }
                options={options}
              />
            </div>
          </div>
        </Container>
      </Navbar>
      <>
        <Dialog
          DialogTitle="Are you sure you want to logout?"
          isVisible={showConfirmDialog}
          onConfirm={handleLogout}
          onCancel={() => handleLogout(false)}
        />
      </>
    </>
  );
};

export default Header;
